<template lang="pug">
  y-dialog(v-model='showModal' max-width='400' scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.px-4.h6.basic800--text {{ $t('update_tracking_info') }}
      v-divider.basic300
      v-container.pa-0.main-container(style="max-width: 600px")
        v-tabs(v-model="tab" fixed-tabs color="textColorAccent" height="40")
          v-tab.button-AA-medium.text-uppercase {{ $t('courier') }}
          v-tab.button-AA-medium(v-if="enabledCourierSelection").text-uppercase {{ $t('on_demand') }}
        div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")
      v-card-text.pb-0.px-4.pt-4
        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        template(v-else)
          v-form(ref="form")
            v-tabs-items(v-model="tab")
              v-tab-item
                v-text-field.p1(v-if="enabledCourierSelection" v-model="searchKeyword" solo flat background-color="basic200" placeholder="Search courier" prepend-inner-icon="mdi-magnify" hide-details dense outlined)
                div.my-3
                  v-item-group(v-if="enabledCourierSelection" v-model="selectedCourier" mandatory)
                    v-row(no-gutters)
                      v-col(v-for="(courier, i) in filteredCouriers" :key="i" cols="3" align="center")
                        v-item.rounded(v-slot="{ active, toggle }" :value="courier.name")
                          v-img.ma-1.pa-2.courier-image(content :src="require('@/assets/images/couriers/'+courier.name+'.png')" :style="imgStyle(active)" @click="toggle")
                            template(v-slot:placeholder)
                              v-row(class="fill-height ma-0" align="center" justify="center")
                                v-progress-circular(indeterminate color="grey")
                p(v-if="filteredCouriers.length == 0 && enabledCourierSelection") {{ $t('no_matching_courier') }}
                p.my-3.label.basic600--text.text-uppercase {{selectedCourier}} {{ $t('tracking_number') }}
                v-text-field(v-if="selectedCourier !== undefined && tab === 0" v-model='trackingId' outlined dense background-color="basic200" height="40" :rules="rules.not_empty" :placeholder="$t('tracking_number.placeholder')")
                  template(v-slot:append)
                    v-img(width="24" height="24" :src="require('@/assets/images/couriers/'+selectedCourier+'.png')")
                      template(v-slot:placeholder)
                        v-row(class="fill-height ma-0" align="center" justify="center")
                          v-progress-circular(indeterminate color="grey")
              v-tab-item
                v-text-field.p1(v-if="enabledCourierSelection" v-model="searchKeyword2" solo flat background-color="basic200" placeholder="Search on-demand" prepend-inner-icon="mdi-magnify" hide-details dense outlined)
                div.my-3
                  v-item-group(v-if="enabledCourierSelection" v-model="selectedOndemand" mandatory)
                    v-row(no-gutters)
                      v-col(v-for="(courier, i) in filteredOndemands" :key="i" cols="3" align="center")
                        v-item.rounded(v-slot="{ active, toggle }" :value="courier.name")
                          v-img.ma-1.pa-2.courier-image(content :src="require('@/assets/images/ondemand/'+courier.name+'.png')" :style="imgStyle(active)" @click="toggle")
                            template(v-slot:placeholder)
                              v-row(class="fill-height ma-0" align="center" justify="center")
                                v-progress-circular(indeterminate color="grey")
                      v-col(cols="12")
                        v-item.rounded(v-slot="{ active, toggle }" value="ownRider")
                          div.ma-1.pa-3.courier-image(:style="imgStyle(active)" @click="toggle")
                            div.c2.primary400--text.text-center {{ $t('i_used_own_rider') }}
                p(v-if="filteredOndemands.length == 0 && enabledCourierSelection") {{ $t('no_matching_on_demand') }}
                div.mt-6.label.basic600--text.text-uppercase {{ $t('tracking_details') }}
                v-textarea.mt-3(v-if="tab === 1" v-model='trackingDetails' outlined dense background-color="basic200" rows="4" counter="500" auto-grow :rules="rules.textarea" placeholder="e.g. tracking link, rider name, rider number, estimated arrival time")
                .guide.d-flex
                  eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15" style="margin-top: -1px")
                  div.c1.basic600--text {{ $t('separate_details_by_enter') }}
      v-card-actions.px-4
        v-spacer
        v-btn.button-Aa-medium(color='grey', text='', @click='closeDialog')
          | {{ skippable ? 'Skip this for now' : 'Cancel' }}
        v-btn.button-AA-medium.white--text(color='info500' depressed height=32
             :disabled="selectedCourier === undefined && selectedOndemand === undefined"
             :loading="isLoading"
             @click='clickSave()')
          | {{ $t('update') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddTrackingCodeDialog',
  props: ['open', 'parentLead','company', 'skippable'],
  data: () => ({
    trackingId: null,
    trackingDetails: null,
    isLoading: false,
    isFetching: false,
    searchKeyword: '',
    searchKeyword2: '',
    couriers: [],
    ondemands: [
      { id: 1, name: 'BungkusIT' },
      { id: 2, name: 'Grab Express' },
      { id: 3, name: 'HaloExpress' },
      { id: 4, name: 'Lalamove' },
      { id: 5, name: 'MatDespatch' },
      { id: 6, name: 'MrSpeedy' },
      { id: 7, name: 'pickupp' },
      { id: 8, name: 'Zepto' }
    ],
    selectedCourier: null,
    selectedOndemand: null,
    tab: 0,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      textarea: [val => (val || '').length > 0 || 'This field is required', val => (val || '').length <= 500 || 'exceed maximum character'],
    }
  }),
  computed: {
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('update:parentLead', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    enabledCourierSelection () {
      return this.lead.shipping.shipping_method == 'manual'
    },
    filteredCouriers () {
      let searchResults = this.couriers.filter((courier) => {
        return courier.name.toLowerCase().includes(this.searchKeyword.toLowerCase())
      })
      return searchResults.slice(0, 12)
    },
    filteredOndemands () {
      let searchResults = this.ondemands.filter((ondemands) => {
        return ondemands.name.toLowerCase().includes(this.searchKeyword2.toLowerCase())
      })
      return searchResults.slice(0, 12)
    }
  },
  mounted () {
    if (this.lead.shipping && this.lead.shipping.tracking_id) {
      this.trackingId = this.lead.shipping.tracking_id
    }
    this.fetchCouriers()
    this.selectedCourier = this.lead.shipping.courier
    this.selectedOndemand = this.lead.shipping.on_demand
    this.trackingDetails = this.lead.shipping.on_demand_details
    if (this.lead.shipping.on_demand) {
      this.tab = 1
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    imgStyle(active){
      return {"border-color": (active? '#3366FF' : "#EEE" ), "opacity": (active? 1.0 : 0.75 )}
    },
    fetchCouriers(){
      //console.log(this.lead.company)
      this.isFetching = true
      this.axios.get(`/shipping/settings/${this.lead.company.slug}/couriers`)
        .then(resp => {
          this.couriers = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.tab === 0) {
        this.trackingDetails = null
        this.selectedOndemand = null
      } else {
        this.trackingId = null
        this.selectedCourier = null
      }
      this.isLoading = true
      this.axios.patch(`/shipping/shippings/${this.lead.shipping.id}/`, {
        on_demand_details: this.trackingDetails,
        on_demand: this.selectedOndemand,
        tracking_id: this.trackingId,
        courier: this.selectedCourier
      })
        .then(resp => {
          this.$set(this.lead.shipping, 'on_demand_details', resp.data.on_demand_details)
          this.$set(this.lead.shipping, 'on_demand', resp.data.on_demand)
          this.$set(this.lead.shipping, 'tracking_id', resp.data.tracking_id)
          this.$set(this.lead.shipping, 'courier', resp.data.courier)
          if (this.skippable) {
            this.$emit('markShipped')
          }
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      if (this.skippable) {
        this.$emit('markShipped')
      }
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.courier-image {
  border: #AAA solid 3px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>

<i18n>
{
  "en": {
    "update_tracking_info": "Update tracking info",
    "no_matching_courier": "No matching courier found",
    "tracking_number": "tracking number",
    "i_used_own_rider": "I used my own rider",
    "no_matching_on_demand": "No matching on-demand found",
    "tracking_details": "Tracking Details",
    "separate_details_by_enter": "Separate details by pressing Enter key"
  },
  "id": {
    "update_tracking_info": "Perbarui info pelacakan",
    "no_matching_courier": "Tiada kurir ditemukan",
    "tracking_number": "Nomor pelacakan",
    "i_used_own_rider": "Guna rider sendiri",
    "no_matching_on_demand": "Tidak ditemukan kecocokan sesuai permintaan",
    "tracking_details": "Detail pelacakan",
    "separate_details_by_enter": "Pisahkan detail dengan menekan tombol Enter"
  }
}
</i18n>
